/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

export const createProjectStatusSchema = z.object({
  name: z.coerce.string(),
});
